import { render, staticRenderFns } from "./PriorityRenderer.vue?vue&type=template&id=b1dbe166&scoped=true&"
import script from "./PriorityRenderer.vue?vue&type=script&lang=js&"
export * from "./PriorityRenderer.vue?vue&type=script&lang=js&"
import style0 from "./PriorityRenderer.vue?vue&type=style&index=0&id=b1dbe166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dbe166",
  null
  
)

/* custom blocks */
import block0 from "./PriorityRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports